
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class MyCheckbox extends Vue {
  @Prop({ default: "", type: String })
  label: string;
  @Prop({ default: "", type: String })
  helpText: string;
  @Prop({ default: "#d9d9d9", type: String })
  iconColor: string;
}
